module.exports = __webpack_public_path__ + "img/data_not_found.ce48d5e2.png";